import gql from 'graphql-tag';

export const createListGql = gql`
  mutation (
    $inst_id: String!
    $account_id: String!
    $filters: FilterExpressionInput
    $attributes: String
    $name: String
    $createUser: String
    $listType: ListTypeEnum!
    $loadAttributes: String
    $listMembership: String
    $audiencesSearch: String
  ) {
    listCreate(
      createUser: $createUser
      instId: $inst_id
      accountId: $account_id
      filters: $filters
      attributes: $attributes
      name: $name
      listType: $listType
      loadAttributes: $loadAttributes
      listMemberShip: $listMembership
      audiencesSearch: $audiencesSearch
      shared: true
    ) {
      data {
        count
        updatedAt
        id
        accountId
        system
        shared
        name
        deletedAt
        orderBy
        attributes
        loadAttributes
      }
      message
      code
    }
  }
`;
export const appendUsersToListGql = gql`
  mutation (
    $inst_id: String!
    $account_id: String!
    $id: String!
    $profiles: [ListAudienceAppendInput!]!
  ) {
    listAudienceAppendIds(
      accountId: $account_id
      instId: $inst_id
      id: $id
      profiles: $profiles
    ) {
      message
      data {
        count
        listType
      }
    }
  }
`;
export const duplicateListGql = gql`
  mutation (
    $inst_id: String!
    $account_id: String!
    $id: String!
    $name: String!
    $audiencesSearch: String
  ) {
    listDuplicate(
      instId: $inst_id
      accountId: $account_id
      id: $id
      name: $name
      audiencesSearch: $audiencesSearch
    ) {
      data {
        updatedAt
        id
        accountId
        system
        shared
        name
        deletedAt
        orderBy
        attributes
        count
      }
      message
      code
    }
  }
`;
